import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createFaq } from "../../../api/boardFaq.api";
import ErrorResponse from "../../../components/ErrorResponse";
import FaqEditor from "../../../components/homepage/faq/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const HomepageFaqCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/faq');
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    submitExecute(createFaq(data));
  }

  return (
    <div className="content scrollbar">
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.faq.title2')}
      />
      <FaqEditor
        submit={submit}
      />
    </div>
  );
}

export default HomepageFaqCreate;
